import { lazy } from 'react';


export const BinanceGeeks = lazy(() => import('./BinanceGeeks'));
